import { render, staticRenderFns } from "./ProjManager.vue?vue&type=template&id=709c9cde&scoped=true"
import script from "./ProjManager.vue?vue&type=script&lang=js"
export * from "./ProjManager.vue?vue&type=script&lang=js"
import style0 from "./ProjManager.vue?vue&type=style&index=0&id=709c9cde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709c9cde",
  null
  
)

export default component.exports